import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import ErrorModalIcon from '../../../../../incase-domain/components/modals/errorModal/ErrorModalIcon';
import ErrorModalContent from '../../../../../incase-domain/components/modals/errorModal/ErrorModalContent';
import ErrorModalCloseButton from '../../../../../incase-domain/components/modals/errorModal/ErrorModalCloseButton';
import ErrorModalWrapper from '../../../../../incase-domain/components/modals/errorModal/ErrorModalWrapper';
import {roomInfoModalSelector} from '../../../../../store/selectors/roomProtection.selector';
import {setRoomInfoModalAction} from '../../../../../store/actions/roomProtection.actions';
import InvalidLinkModalContent from './InvalidLinkModalContent';

function RoomInfoModal(): JSX.Element {
    const navigate = useNavigate();
    const infoModal = useSelector(roomInfoModalSelector);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const title = infoModal.title ? t(infoModal.title) : '';
    const description = infoModal.description ? t(infoModal.description) : '';

    return (
        <ErrorModalWrapper isOpen={infoModal.open}>
            <ErrorModalIcon />
            {infoModal.description && infoModal.descriptionParams ? (
                <InvalidLinkModalContent title={title} description={infoModal.description} params={infoModal.descriptionParams} />
            ) : (
                <ErrorModalContent title={title} description={description} />
            )}
            <ErrorModalCloseButton
                onClose={() => {
                    dispatch(setRoomInfoModalAction(false, '', ''));
                    navigate('/');
                }}
            />
        </ErrorModalWrapper>
    );
}

export default RoomInfoModal;
